/* eslint-disable react-refresh/only-export-components --
   Widget module: the FormWidget registration and its renderer are one plugin. */
import Editor from "@monaco-editor/react";
import { configureSyntaxValidation, problemsLabel, useEditorProblems } from "../../code/editor-problems";
import { FormWidgetService, FormWidgetProps } from "./form-widget-service";

// ── code: a Monaco editor for a column the model marks `widget: "code"` ──
// FEATURE-20261012-zoo-field-ui-metadata-through-firewall-to-pages
//
// A registered form widget ({type:"widget", widget:"code", config:{language}}).
// The page DSL emits it for a field whose model metadata is {widget:"code",
// language:...} (Field.toFieldDef -> getFormItem); a hand-written form can name
// it the same way. The value is the column's text; `language` is a Monaco
// language id (typescript, javascript, sql, json, ...; plaintext when absent).

function CodeWidget({ formItem, formData, setValue }: FormWidgetProps) {
  const language =
    typeof formItem.config?.language === "string" && formItem.config.language !== ""
      ? formItem.config.language
      : "plaintext";
  const raw = formData[formItem.name];
  const value = typeof raw === "string" ? raw : raw == null ? "" : String(raw);
  const { problems, onMount, jumpToFirst } = useEditorProblems();
  const problemText = problemsLabel(problems);
  return (
    <div className="code-widget" style={{ border: "1px solid #343741", borderRadius: 4, overflow: "hidden" }}>
      <Editor
        height="320px"
        language={language}
        theme="vs-dark"
        value={value}
        onChange={(v) => setValue(v ?? "")}
        beforeMount={configureSyntaxValidation}
        onMount={onMount}
        options={{
          readOnly: formItem.disabled === true,
          minimap: { enabled: false },
          fontSize: 13,
          scrollBeyondLastLine: false,
          automaticLayout: true,
          wordWrap: "off",
        }}
      />
      {problemText && (
        <button
          type="button"
          onClick={jumpToFirst}
          title={`${problems.summary}\n\nClick to go to the first one. The value is kept as typed.`}
          style={{
            display: "block",
            width: "100%",
            textAlign: "left",
            padding: "3px 8px",
            border: "none",
            borderTop: "1px solid #343741",
            background: problems.errors > 0 ? "rgba(197, 48, 48, 0.18)" : "rgba(183, 121, 31, 0.15)",
            color: problems.errors > 0 ? "#feb2b2" : "#f6c453",
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          ⚠ {problemText}
          {problems.first ? ` — line ${problems.first.line}: ${problems.first.message}` : ""}
        </button>
      )}
    </div>
  );
}

FormWidgetService.get().register({
  name: "code",
  render: (props) => <CodeWidget {...props} />,
});
